module.exports = __webpack_public_path__ + "static/media/innovar.30de1b7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Section-servicios/Images/innovar.svg
// module id = 132
// module chunks = 0